import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import './index.css';
import { runAuthBridge } from './lib/authBridge';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// App.tsx initialises Firebase Auth at module scope and the SDK only reads
// persisted sessions once, at init. The auth bridge (which seeds a store
// login into this origin's localStorage) must therefore finish before App is
// even imported, hence the dynamic import. runAuthBridge resolves immediately
// when a session already exists, so the usual case adds no delay.
runAuthBridge().then(() =>
  import('./App').then(({ default: App }) => {
    root.render(<App />);
  })
);
